import Icon from '../components/Icon.vue'

Icon.register({
  'space-shuttle': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M592.6 208.2c29.7 13.9 47.4 31.8 47.4 47.8s-17.7 33.8-47.4 47.8c-32.9 15.4-76.8 24.2-120.6 24.2h-285.7c-5 6.6-10.6 12-16.7 16h206.4c-146.8 30.3-156.6 136-280 136h0v-128h-16v128c-26.5 0-48-28.7-48-64v-64c-23.2 0-32-10-32-24v-40c0-14 8.8-24 32-24v-16c-23.2 0-32-10-32-24v-40c0-14 8.8-24 32-24v-64c0-35.3 21.5-64 48-64v128h16v-128h0c123.4 0 133.2 105.7 280 136h-206.4c6.1 4 11.8 9.4 16.7 16h285.7c43.8 0 87.7 8.8 120.6 24.2zM488 296c31.9 0 31.9-80 0-80-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/space-shuttle.js
// module id = 1727
// module chunks = 0